/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { getIdToken } from "./firebase";

const axiosInstance = ({ token }: { token: string }) => {
  const instance = axios.create({
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const get = <T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    config?: AxiosRequestConfig<D>,
  ): Promise<R> => {
    return instance.get(url, config);
  };

  const post = <T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>,
  ): Promise<R> => {
    return instance.post(url, data, config);
  };

  const put = <T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>,
  ): Promise<R> => {
    return instance.put(url, data, config);
  };

  const Delete = <T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    config?: AxiosRequestConfig<D>,
  ): Promise<R> => {
    return instance.delete(url, config);
  };

  return { get, post, put, Delete };
};

const createAxios = async () => {
  const token = await getIdToken();
  return axiosInstance({ token });
};
export default createAxios;
